import { createApi } from "@reduxjs/toolkit/query/react"
import { RootState } from "appRedux/store"
import { baseQueryWithMiddlewares } from "appRedux/baseQuery"
import { updateFeeds, updateFeedHasMore } from "appRedux/slices/feedSlice"

export const feedApi = createApi({
  reducerPath: "feedApi",
  baseQuery: baseQueryWithMiddlewares("/feed"),
  endpoints: (builder) => ({
    getFeed: builder.query<FeedResponseDto, number>({
      query: (page) => page > 1 ? `?page=${page}` : "",
      onQueryStarted: async (page, { dispatch, queryFulfilled, getState }) => {
        try {
          const { data } = await queryFulfilled
          const state = getState() as RootState
          const prevFeeds = state.feed.feeds
          if (page > 1) {
            dispatch(updateFeeds([...prevFeeds, ...data.feed]))
          } else {
            dispatch(updateFeeds(data.feed))
          }
          dispatch(updateFeedHasMore(data.hasMore))
        } catch (error) {
          console.error("Error getting feed:", error)
        }
      }
    })
  })
})

export const {
  useGetFeedQuery,
  useLazyGetFeedQuery
} = feedApi
